import { BookOpen, Plus } from "lucide-react";
import { useState } from "react";
import PlaybookEditor from "./PlaybookEditor";
import PlaybookLibrary from "./PlaybookLibrary";

const Playbooks = () => {
  const [view, setView] = useState("library"); // 'library' or 'editor'
  const [selectedPlaybook, setSelectedPlaybook] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleCreateNew = () => {
    setSelectedPlaybook(null);
    setView("editor");
  };

  const handleEdit = (playbook) => {
    setSelectedPlaybook(playbook);
    setView("editor");
  };

  const handleBack = () => {
    setView("library");
    setSelectedPlaybook(null);
    setRefreshTrigger(p => p + 1);
  };

  return (
    <div className="max-w-7xl mx-auto p-4 md:p-8 animate-fade-in space-y-6">
      
      {/* Header */}
      {view === "library" && (
        <div className="flex justify-between items-center">
            <div>
                <h1 className="text-3xl font-bold text-white tracking-tight flex items-center gap-3">
                    <BookOpen className="text-indigo-400" />
                    The Playbook
                </h1>
                <p className="text-slate-400 mt-1">Your library of high-probability setups.</p>
            </div>
            <button 
                onClick={handleCreateNew}
                className="bg-indigo-600 hover:bg-indigo-500 text-white px-4 py-2 rounded-lg font-medium flex items-center gap-2 transition-all shadow-lg shadow-indigo-500/20"
            >
                <Plus size={18} /> New Play
            </button>
        </div>
      )}

      {view === "library" ? (
        <PlaybookLibrary onEdit={handleEdit} refreshTrigger={refreshTrigger} />
      ) : (
        <PlaybookEditor 
            initialData={selectedPlaybook} 
            onBack={handleBack} 
            onSaveSuccess={handleBack} 
        />
      )}

    </div>
  );
};

export default Playbooks;
